/**
 * Main chain / side chain of a polymer residue's atoms, for rep sets scoped to either part
 * (Advanced styles, plan B3 option B Stage 3c; AtomGroupStyle.scopedReps).
 *
 *   main chain  N, C, O, OXT of amino acids; the phosphate-sugar backbone of nucleotides
 *   side chain  everything else (a nucleotide's base)
 *   both        CA / C1': the cartoon hangs on CA, and side-chain sticks need it to reach the
 *               main chain, so it draws the reps of both parts
 * A hydrogen belongs where its heavy atom does.
 */

/** @typedef {'mainchain'|'sidechain'|'both'} ChainScope */

export const ChainScopes = ['mainchain', 'sidechain'];

const MainChainNames = new Set([
    // amino acids
    'N', 'C', 'O', 'OXT',
    // nucleotides
    'P', 'OP1', 'OP2', 'OP3', 'O1P', 'O2P', 'O3P', "O5'", "C5'", "C4'", "O4'", "C3'", "O3'",
    "C2'", "O2'",
]);
const BothNames = new Set(['CA', "C1'"]);

function heavyScope(name) {
    if (BothNames.has(name)) return 'both';
    return MainChainNames.has(name) ? 'mainchain' : 'sidechain';
}

/**
 * @param {{atom: string, elem?: string, bondedAtoms?: object[]}} atom a polymer residue's atom
 * @returns {ChainScope}
 */
export function chainScopeOf(atom) {
    if (atom.elem === 'H') {
        const heavy = (atom.bondedAtoms || []).find((other) => other.elem !== 'H');
        if (heavy) return heavyScope(heavy.atom);
    }
    return heavyScope(atom.atom);
}
